export default __webpack_public_path__ + "static/media/lorem-ipsum-generator-light.5fd23954.png";